import { render, staticRenderFns } from "./PreviewGroup.vue?vue&type=template&id=4074f0c2&scoped=true&"
import script from "./PreviewGroup.vue?vue&type=script&lang=js&"
export * from "./PreviewGroup.vue?vue&type=script&lang=js&"
import style0 from "./PreviewGroup.vue?vue&type=style&index=0&id=4074f0c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074f0c2",
  null
  
)

export default component.exports